import { controls, grouped } from "../controls";
const agri_ledgers = {
  label: "Agri Ledgers",
  pageLabel: "Agri Ledgers", starting: true, url: "autogen",
  formActions: { edit: { allow: true }, delete: { allow: true } },
  pageType: "history",
  filter: [
    ...controls.displayText({ tab: "filter", label: "Society" }),
    ...controls.oc({ tab: "filter", length: 4, c: "Society", placeHolder: "Society Code", name: "AgriLedger-society-society_code", fastpath: "societies" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "AgriLedger-society-society_display" }),
  ]
  , form: [

    ...grouped.trnsummary(),

    {
      widths: "col-sm-9",
      tab: "general",
      style: { marginTop: 5, border: 0, paddingLeft: 0, paddingRight: 0 },
      direction: 'vertical',
      pagination: { perPage: 30, buttonSize: 'col-sm-2' },
      subComponents: [
        ...controls.displayText({ tab: "general", label: "Code" }),
        ...controls.oc({ tab: "general", c: "Customer", placeHolder: "Code", name: "bank_customer_code", displayData: { gender: "gender_display", pan: "pan_customer", aadhaar: "aadhaar_customer", mothers_name: "mothers_name_customer", religion: "religion_display", caste: "caste_display", mobile: "mobile_customer", dob: "dob_customer" }, hidden: false }),
        ...controls.showData({ tab: "general", displaytype: "capital", data: "bank_customer_display" }),
        ...controls.displayText({ tab: "general", label: "Code" }),
        ...controls.oc({ tab: "general", c: "Account", placeHolder: "Code", name: "bank_account_code", hidden: false }),
        ...controls.showData({ tab: "general", displaytype: "capital", data: "bank_account_display" }),
        ...controls.magicDateLabel({ tab: "general", label: "Disbursement Date", target: "disbursement_date", star: false }),
        ...controls.magicDate({ tab: "general", name: "disbursement_date", dateType: "ontype" }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
        ...controls.displayText({ tab: "general", label: "Sanctioned Amount" }),
        ...controls.floatOnly({ tab: "general", placeHolder: "", name: "sanctioned_amount", maxlength: 18 }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
        ...controls.displayText({ tab: "general", label: "Opening Balance" }),
        ...controls.floatOnly({ tab: "general", placeHolder: "", name: "opening_balance", maxlength: 18 }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
        ...controls.displayText({ tab: "general", label: "Closing Balance" }),
        ...controls.floatOnly({ tab: "general", placeHolder: "", name: "closing_balance", maxlength: 18 }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
        ...controls.displayText({ tab: "general", label: "Page Number", star: false }),
        ...controls.numberOnly({ tab: "general", placeHolder: "", name: "page_number", maxlength: 200 }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
        ...controls.displayText({ tab: "general", label: "Crop", star: false }),
        ...controls.oc({ tab: "general", c: "Crop", placeHolder: "Crop Code", name: "crop_code", fastpath: "crops", hidden: false }),
        ...controls.showData({ tab: "general", displaytype: "capital", data: "crop_display" }),
        ...controls.displayText({ tab: "general", label: "Gender", star: false }),
        ...controls.autoComplete({ tab: "general", name: "gender_code", width: "col-sm-2", controlType: "Gender" }),
        ...controls.displayText({ tab: "general", label: "" }),
        ...controls.displayText({ tab: "general", label: "Religion", star: false }),
        ...controls.autoComplete({ tab: "general", name: "religion_code", width: "col-sm-2", controlType: "Religion" }),
        ...controls.displayText({ tab: "general", label: "" }),
        ...controls.displayText({ tab: "general", label: "Caste", star: false }),
        ...controls.autoComplete({ tab: "general", name: "caste_code", width: "col-sm-2", controlType: "Caste" }),
        ...controls.displayText({ tab: "general", label: "" }),
        ...controls.displayText({ tab: "general", label: "Mothers Name", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "mothers_name", maxlength: 30 }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
        ...controls.displayText({ tab: "general", label: "Aadhaar", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "aadhaar", maxlength: 30 }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
        ...controls.displayText({ tab: "general", label: "Pan", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "pan", maxlength: 30 }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
        ...controls.displayText({ tab: "general", label: "Mobile", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "mobile", maxlength: 30 }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
        ...controls.displayText({ tab: "general", label: "Society", star: true }),
        ...controls.oc({ tab: "general", length: 4, c: "Society", placeHolder: "Society Code", name: "society_code", isRequired: true, fastpath: "societies", hidden: false }),
        ...controls.showData({ tab: "general", displaytype: "capital", data: "society_display" }),
        ...controls.displayText({ tab: "general", label: "Disbursed Amount" }),
        ...controls.floatOnly({ tab: "general", placeHolder: "", name: "disbursed_amount", maxlength: 18 }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
        ...controls.checkBox({ tab: "general", label: "Is Restructured", default: false, name: "is_restructured" }),
        ...controls.magicDateLabel({ tab: "general", label: "Restructure Date", target: "restructure_date", star: false }),
        ...controls.magicDate({ tab: "general", name: "restructure_date", dateType: "ontype" }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
        ...controls.displayText({ tab: "general", label: "Hector" }),
        ...controls.floatOnly({ tab: "general", placeHolder: "", name: "hector", maxlength: 10 }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
        ...controls.displayText({ tab: "general", label: "Aar" }),
        ...controls.floatOnly({ tab: "general", placeHolder: "", name: "aar", maxlength: 10 }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
        ...controls.displayText({ tab: "general", label: "Overdue Principal" }),
        ...controls.floatOnly({ tab: "general", placeHolder: "", name: "overdue_principal", maxlength: 18 }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
        ...controls.displayText({ tab: "general", label: "Overdue Interest" }),
        ...controls.floatOnly({ tab: "general", placeHolder: "", name: "overdue_interest", maxlength: 18 }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
        ...controls.magicDateLabel({ tab: "general", label: "Npa Date", target: "npa_date", star: false }),
        ...controls.magicDate({ tab: "general", name: "npa_date", dateType: "ontype" }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
        ...controls.displayText({ tab: "general", label: "Balance On Npa Date" }),
        ...controls.floatOnly({ tab: "general", placeHolder: "", name: "balance_on_npa_date", maxlength: 18 }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
        ...controls.checkBox({ tab: "general", label: "Is Inherited", default: false, name: "is_inherited" }),
        {
          widths: "col-sm-12",
          tab: "general",
          title: "Legacy Agri Transactions",
          subComponents: [

            {
              widths: "col-sm-12",
              tab: "general",
              style: { border: 0, paddingLeft: 0, paddingRight: 0 },
              direction: 'vertical',
              pagination: { perPage: 30, buttonSize: 'col-sm-2' },
              subComponents: [
                ...controls.magicDateLabel({ tab: "general", label: "Date", target: "date", star: false }),
                ...controls.magicDate({ tab: "general", name: "date", dateType: "ontype" }),
                ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
                ...controls.checkBox({ tab: "general", label: "Is Credit", default: false, name: "is_credit", width: "col-sm-6" }),
                ...controls.displayText({ tab: "general", label: "Amount", star: false }),
                ...controls.numtoword({ tab: "general", placeHolder: "", name: "amount", maxlength: 18.2, textwidth: "col-sm-6" }),
                ...controls.displayText({ tab: "general", label: "Agri Transaction Type", star: false }),
                ...controls.oc({ tab: "general", c: "AgriTransactionType", placeHolder: "Agri Transaction Type Code", name: "agri_transaction_type_code", fastpath: "agri_transaction_types", autoopen: true, hidden: false }),
                ...controls.showData({ tab: "general", displaytype: "capital", data: "agri_transaction_type_display" }),
                ...controls.displayText({ tab: "general", label: "Particulars", star: false }),
                ...controls.text({ tab: "general", placeHolder: "", name: "particulars", width: "col-sm-4", maxlength: 100 }),
                ...controls.displayText({ tab: "legacy_agri_transactions", width: "col-sm-12", label: "" }),
                ...controls.displayText({ tab: "legacy_agri_transactions", width: "col-sm-4", label: "" }),
                ...controls.button({
                  tab: "legacy_agri_transactions",
                  label: "ADD",
                  style: { padding: 0 },
                  Bcolor: "success",
                  onclick: {
                    action: "appendToHTMLTable",
                    tableNameField: "legacy_agri_transactions",
                    requiredField: ["date", "is_credit", "amount", "agri_transaction_type_code", "agri_transaction_type_display", "agri_transaction_type_uid", "particulars",]
                  }, width: "col-sm-2"
                }),
                ...controls.button({
                  tab: "legacy_agri_transactions",
                  label: "CLEAR",
                  style: { padding: 0 },
                  Bcolor: "warning",
                  onclick: {
                    action: "clearForm",
                    tableNameField: "legacy_agri_transactions",
                    requiredField: ["date", "is_credit", "amount", "agri_transaction_type_code", "agri_transaction_type_display", "agri_transaction_type_uid", "particulars",]
                  }, width: "col-sm-2"
                }),
              ]
            },
            {
              tab: "legacy_agri_transactions",
              inputType: "table",
              tableTitle: "",
              deletable: true,
              editable: true,
              tableHeaders: [
                { label: "Sr", type: "autoinc" },
                { label: "Date", field: "date", displaytype: "date" },
                { label: "Is Credit", field: "is_credit", displaytype: "tick" },
                { label: "Amount", field: "amount" },
                { label: "Agri Transaction Type ", field: "agri_transaction_type_display" },
                { label: "Particulars", field: "particulars" },
              ],
              widths: {
                parent: "col-sm-12",
                children: "col-sm-12"
              },
              name: "legacy_agri_transactions",
              onRender: [
                { f: 'tableCalculations', calcType: 'sum', inputs: { source: 'pageData.legacy_agri_transactions', field: 'amount', filter: { is_credit: true } }, resultVar: 'totalCredit' },
                { f: 'setParentState', inputs: { dest: "pageData.total_credit", source: 'allResults', field: 'totalCredit' }, resultVar: "totalCreditT" },

                { f: 'tableCalculations', calcType: 'sum', inputs: { source: 'pageData.legacy_agri_transactions', field: 'amount', filter: { is_credit: false } }, resultVar: 'totalDebit' },
                { f: 'setParentState', inputs: { dest: "pageData.total_debit", source: 'allResults', field: 'totalDebit' }, resultVar: "totalDebitT" },

                { f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'allResults', field: 'totalCredit' }, { source: 'allResults', field: 'totalDebit', mult: { source: "fixed", val: -1 } }], resultVar: 'difference' },
                { f: 'setParentState', inputs: { dest: "pageData.final_amount", source: 'allResults', field: 'difference' }, resultVar: "totalDebitT" },
              ]
            },
          ]
        },
        {
          widths: "col-sm-12",
          tab: "general",
          title: "Agri Ledger Farms",
          subComponents: [

            {
              widths: "col-sm-12",
              tab: "general",
              style: { border: 0, paddingLeft: 0, paddingRight: 0 },
              direction: 'vertical',
              pagination: { perPage: 30, buttonSize: 'col-sm-2' },
              subComponents: [
                ...controls.displayText({ tab: "general", label: "Customer", star: false }),
                ...controls.oc({ tab: "general", c: "Customer", placeHolder: "Customer Code", name: "customer_code", fastpath: "customers", isReadOnly: "edit", hidden: false }),
                ...controls.showData({ tab: "general", displaytype: "capital", data: "customer_display" }),
                ...controls.displayText({ tab: "general", label: "District", star: false }),
                ...controls.oc({ tab: "general", c: "District", placeHolder: "District Code", name: "district_code", fastpath: "districts", hidden: false }),
                ...controls.showData({ tab: "general", displaytype: "capital", data: "district_display" }),
                ...controls.displayText({ tab: "general", label: "Taluka", star: false }),
                ...controls.oc({ tab: "general", c: "Taluka", placeHolder: "Taluka Code", name: "taluka_code", fastpath: "talukas", hidden: false }),
                ...controls.showData({ tab: "general", displaytype: "capital", data: "taluka_display" }),
                ...controls.displayText({ tab: "general", label: "Village", star: false }),
                ...controls.oc({ tab: "general", c: "Village", placeHolder: "Village Code", name: "village_code", fastpath: "villages", hidden: false }),
                ...controls.showData({ tab: "general", displaytype: "capital", data: "village_display" }),
                ...controls.displayText({ tab: "general", label: "Khata No", star: false }),
                ...controls.text({ tab: "general", placeHolder: "", name: "khata_no", maxlength: 10 }),
                ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
                ...controls.displayText({ tab: "general", label: "Survey No", star: false }),
                ...controls.text({ tab: "general", placeHolder: "", name: "survey_no", maxlength: 10 }),
                ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
                ...controls.displayText({ tab: "general", label: "Gat No", star: false }),
                ...controls.text({ tab: "general", placeHolder: "", name: "gat_no", maxlength: 10 }),
                ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
                ...controls.displayText({ tab: "general", label: "Jirayat Quantity" }),
                ...controls.floatOnly({ tab: "general", placeHolder: "", name: "jirayat_quantity", maxlength: 10 }),
                ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
                ...controls.displayText({ tab: "general", label: "Bagayat Quantity" }),
                ...controls.floatOnly({ tab: "general", placeHolder: "", name: "bagayat_quantity", maxlength: 10 }),
                ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
                ...controls.displayText({ tab: "general", label: "Tari Quantity" }),
                ...controls.floatOnly({ tab: "general", placeHolder: "", name: "tari_quantity", maxlength: 10 }),
                ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
                ...controls.displayText({ tab: "general", label: "Warkas Quantity" }),
                ...controls.floatOnly({ tab: "general", placeHolder: "", name: "warkas_quantity", maxlength: 10 }),
                ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
                ...controls.displayText({ tab: "general", label: "Other Quantity" }),
                ...controls.floatOnly({ tab: "general", placeHolder: "", name: "other_quantity", maxlength: 10 }),
                ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
                ...controls.displayText({ tab: "general", label: "Pot Kharab Quantity" }),
                ...controls.floatOnly({ tab: "general", placeHolder: "", name: "pot_kharab_quantity", maxlength: 10 }),
                ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
                ...controls.displayText({ tab: "general", label: "Mortgage Amount" }),
                ...controls.floatOnly({ tab: "general", placeHolder: "", name: "mortgage_amount", maxlength: 18 }),
                ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
                ...controls.displayText({ tab: "general", label: "Mortgage Authority", star: false }),
                ...controls.text({ tab: "general", placeHolder: "", name: "mortgage_authority", maxlength: 50 }),
                ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
                ...controls.displayText({ tab: "general", label: "Crop", star: false }),
                ...controls.oc({ tab: "general", c: "Crop", placeHolder: "Crop Code", name: "crop_code", fastpath: "crops", hidden: false }),
                ...controls.showData({ tab: "general", displaytype: "capital", data: "crop_display" }),
                ...controls.displayText({ tab: "general", label: "Latitude" }),
                ...controls.floatOnly({ tab: "general", placeHolder: "", name: "latitude", maxlength: 10 }),
                ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
                ...controls.displayText({ tab: "general", label: "Longitude" }),
                ...controls.floatOnly({ tab: "general", placeHolder: "", name: "longitude", maxlength: 10 }),
                ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
                ...controls.checkBox({ tab: "general", label: "Is Tenant", default: false, name: "is_tenant" }),
                ...controls.displayText({ tab: "agri_ledger_farms", width: "col-sm-12", label: "" }),
                ...controls.displayText({ tab: "agri_ledger_farms", width: "col-sm-4", label: "" }),
                ...controls.button({
                  tab: "agri_ledger_farms",
                  label: "ADD",
                  style: { padding: 0 },
                  Bcolor: "success",
                  onclick: {
                    action: "appendToHTMLTable",
                    tableNameField: "agri_ledger_farms",
                    requiredField: ["customer_code", "customer_display", "customer_uid", "district_code", "district_display", "district_uid", "taluka_code", "taluka_display", "taluka_uid", "village_code", "village_display", "village_uid", "khata_no", "survey_no", "gat_no", "jirayat_quantity", "bagayat_quantity", "tari_quantity", "warkas_quantity", "other_quantity", "pot_kharab_quantity", "mortgage_amount", "mortgage_authority", "crop_code", "crop_display", "crop_uid", "latitude", "longitude", "is_tenant",]
                  }, width: "col-sm-2"
                }),
                ...controls.button({
                  tab: "agri_ledger_farms",
                  label: "CLEAR",
                  style: { padding: 0 },
                  Bcolor: "warning",
                  onclick: {
                    action: "clearForm",
                    tableNameField: "agri_ledger_farms",
                    requiredField: ["customer_code", "customer_display", "customer_uid", "district_code", "district_display", "district_uid", "taluka_code", "taluka_display", "taluka_uid", "village_code", "village_display", "village_uid", "khata_no", "survey_no", "gat_no", "jirayat_quantity", "bagayat_quantity", "tari_quantity", "warkas_quantity", "other_quantity", "pot_kharab_quantity", "mortgage_amount", "mortgage_authority", "crop_code", "crop_display", "crop_uid", "latitude", "longitude", "is_tenant",]
                  }, width: "col-sm-2"
                }),
              ]
            },
            {
              tab: "agri_ledger_farms",
              inputType: "table",
              tableTitle: "",
              deletable: true,
              editable: true,
              tableHeaders: [
                { label: "Sr", type: "autoinc" },
                { label: "Customer ", field: "customer_display" },
                { label: "District ", field: "district_display" },
                { label: "Taluka ", field: "taluka_display" },
                { label: "Village ", field: "village_display" },
                { label: "Khata No", field: "khata_no" },
                { label: "Survey No", field: "survey_no" },
                { label: "Gat No", field: "gat_no" },
                { label: "Jirayat Quantity", field: "jirayat_quantity" },
                { label: "Bagayat Quantity", field: "bagayat_quantity" },
                { label: "Tari Quantity", field: "tari_quantity" },
                { label: "Warkas Quantity", field: "warkas_quantity" },
                { label: "Other Quantity", field: "other_quantity" },
                { label: "Pot Kharab Quantity", field: "pot_kharab_quantity" },
                { label: "Mortgage Amount", field: "mortgage_amount" },
                { label: "Mortgage Authority", field: "mortgage_authority" },
                { label: "Crop ", field: "crop_display" },
                { label: "Latitude", field: "latitude" },
                { label: "Longitude", field: "longitude" },
                { label: "Is Tenant", field: "is_tenant", displaytype: "tick" },
              ],
              widths: {
                parent: "col-sm-12",
                children: "col-sm-12"
              },
              name: "agri_ledger_farms"
            },
          ]
        },

      ]
    }, grouped.customerinfo('general')]
  , history: {
    perPage: 10,
    reportHeader: "Agri Ledgers",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
      { Header: "Society", accessor: "AgriLedger-society-society_display", },
      { Header: "Disbursement Date", accessor: "disbursement_date", type: 'date' },
      { Header: "Sanctioned Amount", accessor: "sanctioned_amount", },
      { Header: "Opening Balance", accessor: "opening_balance", },
      { Header: "Closing Balance", accessor: "closing_balance", },
      { Header: "Page Number", accessor: "page_number", },
    ]
  }
};
export default agri_ledgers;